module.exports = __webpack_public_path__ + "media/images/workplace/job_type_bg/job_type_background_data_collection-976d3eb232ac59af3287a9de64f15183.svg";